<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Hak Akses</h2>

      <br />

      <div class="btn-bar">
        <router-link
          to="/pengaturan/hak-akses/-1"
          class="btn-fill btn-width-auto"
        >
          Tambah Hak Akses
        </router-link>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Nama</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              @click="validateAkses(item)"
            >
              <td>{{ item.nama }}</td>
              <td>
                <span
                  v-if="item.id > 1"
                  @click.stop="confirmHapus(item)"
                  class="btn-hapus"
                >
                  Hapus
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
import Search from "../icons/Search.vue";
import Close from "../icons/Close.vue";

export default {
  name: "Hak Akses",
  components: {
    Search,
    Close,
  },
  data() {
    return {
      loading: false,
      data: [],
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/setting/user-akses?id_toko=" +
            this.$toko.id +
            "&tipe=DESKTOP"
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    confirmHapus(item) {
      if (confirm("Hapus " + item.nama + "?")) {
        api.post("/v1/hak-akses/delete", item).then((r) => {
          this.$toast("Berhasil dihapus");
          this.loadData();
        });
      }
    },
    validateAkses(item) {
      if (item.id > 1) {
        this.$router.push("/pengaturan/hak-akses/" + item.id);
      } else {
        this.$toast("Hak akses tidak dapat diubah");
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 15px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    input {
      width: 100%;
    }
  }

  .btn-grid {
    display: grid;
    grid-template-columns: 1fr 50px;
    grid-column-gap: 10px;
    form {
      width: 300px;
      input {
        width: 100%;
      }
    }
    .btn-search {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .table-wrapper {
    margin-top: 15px;
    height: calc(100vh - 270px);
  }

  .modal {
    position: fixed;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    .modal-body {
      background: #fff;
      width: 800px;
      height: 500px;
      padding: 20px;
      margin-top: 100px;
      border-radius: 7px;
      overflow: auto;
      h3 {
        margin: 0;
      }
      a {
        color: var(--primary);
        text-decoration: none;
        &:hover {
          font-weight: bold;
        }
      }
      input {
        width: auto;
      }
      .button-bar {
        display: flex;
        justify-content: space-between;
        margin: 15px 0 10px;
      }

      table {
        tr.animate-flicker {
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pengaturan/HakAkses.vue